import type { IExercise } from '../exercises';

export const KAISHENG_EPISODE_01_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-ksw-collection-01-01",
    "name": "热身_胸大肌放松",
    "bodyPart": "warmup",
    "equipment": "foam-roller",
    "subCategory": "chest",
    "tips": ["侧卧，泡沫轴放胸大肌位置滚动", "找到紧张点停留 20-30 秒"],
    "sets": 1,
    "reps": "1-2分钟",
    "rpe": 2,
    "restSeconds": 0,
    "isBodyweight": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集 · 第1期",
    "demoUrl": "/media/collections-20261008/demos/8d70d3a9424ea964b5f9edbc.mp4",
    "videoUrl": "/media/collections-20261008/videos/e65ae8bf29cd7d8049d93823.mp4",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-01-02",
    "name": "热身_胸小肌放松",
    "bodyPart": "warmup",
    "equipment": "foam-roller",
    "subCategory": "chest",
    "tips": ["泡沫轴放胸小肌处，缓慢滚动找酸痛点停留呼吸", "每侧各做 1-2 分钟"],
    "sets": 1,
    "reps": "1-2分钟",
    "rpe": 2,
    "restSeconds": 0,
    "isBodyweight": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集 · 第1期",
    "demoUrl": "/media/collections-20261008/demos/a1296a1fae30718feb1c9e14.mp4",
    "videoUrl": "/media/collections-20261008/videos/26ce4d085075fd297d5d5fd2.mp4",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-01-03",
    "name": "热身_前锯肌激活",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "chest",
    "tips": ["俯卧撑位，肩胛骨前引再收回", "感受前锯肌发力，核心稳定不塌腰"],
    "sets": 2,
    "reps": "15",
    "rpe": 3,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集 · 第1期",
    "demoUrl": "/media/collections-20261008/demos/a1cb8ece40236e1fda672716.mp4",
    "videoUrl": "/media/collections-20261008/videos/7532f1816687a87aad73bdfe.mp4",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-01-04",
    "name": "热身_下斜方激活Y字",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "thoracic",
    "tips": ["俯身成Y字，拇指朝上抬臂", "感受下斜方肌收紧，沉肩不耸肩"],
    "sets": 2,
    "reps": "15",
    "rpe": 3,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集 · 第1期",
    "demoUrl": "/media/collections-20261008/demos/699413556c02fd3b9dcf2dd7.mp4",
    "videoUrl": "/media/collections-20261008/videos/d2b368a6dd728fd0160f7369.mp4",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-01-05",
    "name": "热身_肩部激活弹力带",
    "bodyPart": "warmup",
    "equipment": "resistance-band",
    "subCategory": "general",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 2,
    "reps": "15",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "demoUrl": "/media/collections-20261008/demos/ed440ad0b84b70bb9a58a2e6.mp4",
    "videoUrl": "/media/collections-20261008/videos/c1780172a2fa00412d765ca8.mp4",
    "source": "凯圣王合集 · 第1期",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-01-06",
    "name": "热身_手腕激活",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "general",
    "tips": ["手腕做前后左右环绕+屈伸", "充分活动腕关节，预防卧推受伤"],
    "sets": 2,
    "reps": "15",
    "rpe": 2,
    "restSeconds": 20,
    "isBodyweight": true,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集 · 第1期",
    "demoUrl": "/media/collections-20261008/demos/7fac2477940d76580e2d954f.mp4",
    "videoUrl": "/media/collections-20261008/videos/5d98ed83997a5021f2afd449.mp4",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-01-07",
    "name": "热身_二头肌放松",
    "bodyPart": "warmup",
    "equipment": "foam-roller",
    "subCategory": "general",
    "tips": ["泡沫轴放上臂前侧二头肌位置", "缓慢滚动，放松紧张的二头和前臂"],
    "sets": 1,
    "reps": "1-2分钟",
    "rpe": 2,
    "restSeconds": 0,
    "isBodyweight": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "凯圣王合集 · 第1期",
    "demoUrl": "/media/collections-20261008/demos/1b5c1f8659e7da7294c12c20.mp4",
    "videoUrl": "/media/collections-20261008/videos/f233dfa332a70ff3ed5b6540.mp4",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-01-08",
    "name": "杠铃卧推",
    "bodyPart": "chest",
    "equipment": "barbell",
    "subCategory": "mid-chest",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 4,
    "reps": "8-12",
    "rpe": 8,
    "restSeconds": 90,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["胸大肌", "三角肌前束"],
    "demoUrl": "/media/collections-20261008/demos/f19982964ab9dfe40c5fb146.mp4",
    "videoUrl": "/media/collections-20261008/videos/e2339d3f382f1aa02b7e5c63.mp4",
    "source": "凯圣王合集 · 第1期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-01-09",
    "name": "哑铃上斜卧推",
    "bodyPart": "chest",
    "equipment": "dumbbell",
    "subCategory": "upper-chest",
    "tips": ["按新视频示范保持上斜角度", "控制下降和推起节奏"],
    "sets": 4,
    "reps": "8-12",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["胸大肌上部", "三角肌前束", "肱三头肌"],
    "demoUrl": "/media/collections-20261008/demos/e2bad5482f361b8d4eddecb4.mp4",
    "videoUrl": "/media/collections-20261008/videos/24a31f72421c7cb298aea7da.mp4",
    "source": "凯圣王合集 · 第1期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-01-10",
    "name": "双杠臂屈伸",
    "bodyPart": "chest",
    "equipment": "bodyweight",
    "subCategory": "lower-chest",
    "tips": ["身体前倾重心前移，侧重下胸", "下放至大臂平行于地面或略低"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 90,
    "isBodyweight": true,
    "difficulty": "advanced",
    "targetMuscles": ["下胸肌", "胸大肌"],
    "source": "凯圣王合集 · 第1期",
    "demoUrl": "/media/collections-20261008/demos/431d6ec97ce45fecaf34f66a.mp4",
    "videoUrl": "/media/collections-20261008/videos/1cb8b33d71263351741a55ae.mp4",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-01-11",
    "name": "仰卧屈伸",
    "bodyPart": "arms",
    "equipment": "barbell",
    "subCategory": "triceps",
    "tips": ["大臂保持垂直", "曲杆杠铃更护肘"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/51a2cb83e7854c906b808dd1.mp4",
    "videoUrl": "/media/collections-20261008/videos/993b12c516ffaee5936061e4.mp4",
    "targetMuscles": ["肱三头肌"],
    "difficulty": "intermediate",
    "source": "凯圣王合集 · 第1期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-ksw-collection-01-12",
    "name": "Y字侧平举",
    "bodyPart": "shoulders",
    "equipment": "cable",
    "subCategory": "side-deltoid",
    "tips": ["俯身或俯卧，手臂呈Y字展开", "用三角肌后束发力，10次+10次递减组"],
    "sets": 3,
    "reps": "10+10",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["三角肌中束"],
    "source": "凯圣王合集 · 第1期",
    "demoUrl": "/media/collections-20261008/demos/bad69d54f23d00889849e52c.mp4",
    "videoUrl": "/media/collections-20261008/videos/ffad626514b8d937fc348150.mp4",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
];
